import React, { useState } from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import { FaWhatsapp, FaTimes, FaTelegramPlane } from 'react-icons/fa';
import config from '../../../config/config';
import { useTranslation } from 'react-i18next';
import './WhatsAppChat.css';

const WhatsAppChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const { t } = useTranslation();
  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (message.trim()) {
      // Format the message for WhatsApp
      const encodedMessage = encodeURIComponent(message);
      // Open WhatsApp with the pre-filled message using the correct format
      window.open(`https://api.whatsapp.com/send?phone=${config.contact.whatsapp}&text=${encodedMessage}`, '_blank');
      // Reset the form
      setMessage('');
    }
  };

  return (
    <>
      <motion.button 
        className="chat-button"
        onClick={() => setIsOpen(true)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        aria-label="Ouvrir la conversation"
      >
        <FaWhatsapp />
      </motion.button>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="chat-window"
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            transition={{ duration: 0.3 }}
          >
            <div className="chat-header">
              <div className="header-logo">
                <FaWhatsapp />
              </div>
              <div className="header-text">
                <h3 className="header-title">{t('whatsapp.chat_with_us')}</h3>
                <p className="header-subtitle">{t('whatsapp.online_now')}</p>
              </div>
              <button className="close-button" onClick={() => setIsOpen(false)}>
                <FaTimes />
              </button>
            </div>
            
            <div className="chat-body">
              <div className="chat-message">
                <p className="message-text">
                  {t('whatsapp.welcome_message')}
                </p>
                <span className="message-time">
                  {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
            </div>
            
            <form className="chat-form" onSubmit={handleSubmit}>
              <input 
                className="chat-input"
                type="text" 
                placeholder={t('whatsapp.type_message')}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button className="send-button" type="submit">
                <FaTelegramPlane  />
              </button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default WhatsAppChat;
